import { BaseModel } from "../../../../core/_base/crud";

export class TimKiemNangCaoModel extends BaseModel {
    IdLoai : number
    MaLoai : string
    TenLoai : string
    IdNhom : number
    MaNhom : string
    TenNhom : string
    IdHH : number
    MaHH : string
    TenHH : string
    QuyCach : string
    clear(){
        this.IdLoai  = 0
        this.MaLoai = ''
        this.TenLoai = ''
        this.IdNhom  = 0
        this.MaNhom = ''
        this.TenNhom = ''
        this.IdHH  = 0
        this.MaHH = ''
        this.TenHH = ''
        this.QuyCach = ''
    }

    copy(item: TimKiemNangCaoModel){
        this.IdLoai = item.IdLoai
        this.MaLoai = item.MaLoai
        this.TenLoai = item.TenLoai
        this.IdNhom  = item.IdNhom
        this.MaNhom = item.MaNhom
        this.TenNhom = item.TenNhom
        this.IdHH  = item.IdHH
        this.MaHH = item.MaHH
        this.TenHH = item.TenHH
        this.QuyCach = item.QuyCach
    }
}